'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('@marmalade/prop-types');
var _select = require('../select');
var _select2 = _interopRequireDefault(_select);
var _controlFields = require('../../hocs/control-fields');
var _controlFields2 = _interopRequireDefault(_controlFields);
var _vehicleLookup = require('../../selectors/vehicle-lookup');
var _vehicleLookup2 = require('../../actions/vehicle-lookup');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var fields = [{
  name: 'manufacturerOptions',
  action: 'getModelOptions',
  type: 'select',
  label: 'What is the car manufacturer?'
}, {
  name: 'modelOptions',
  action: 'getTransOptions',
  type: 'select',
  label: 'What is the car model?'
}, {
  name: 'transOptions',
  action: 'getFuelOptions',
  type: 'select',
  label: 'What is the gearbox type?'
}, {
  name: 'fuelOptions',
  action: 'getEngineOptions',
  type: 'select',
  label: 'What is the fuel type?'
}, {
  name: 'engineOptions',
  action: 'getTrimOptions',
  type: 'select',
  label: 'What is the engine size?'
}, {
  name: 'trimOptions',
  action: 'getDoorsOptions',
  type: 'select',
  label: 'What is the model trim?'
}, {
  name: 'doorsOptions',
  action: 'getYearOptions',
  type: 'select',
  label: 'How many doors?'
}, {
  name: 'yearOptions',
  action: 'getVehicle',
  type: 'select',
  label: 'What is the car year?'
}];
var ManualLookup = function (_Component) {
  _inherits(ManualLookup, _Component);
  function ManualLookup() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ManualLookup);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ManualLookup.__proto__ || Object.getPrototypeOf(ManualLookup)).call.apply(_ref, [this].concat(args))), _this), _this.fetchOptions = function (action, name) {
      return function () {
        _this.props.fetchOptions(_this.props.formId, _this.props.product, action, name);
      };
    }, _this.resetLookup = function () {
      _this.props.resetLookup();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ManualLookup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof this.props.options !== 'undefined' && !this.props.options.manufacturerOptions.length) {
        this.props.fetchOptions(this.props.formId, this.props.product, 'getManufacturerOptions');
      }
    }
  }, {
    key: 'createOption',
    value: function createOption(index) {
      var field = fields[index];
      var disabled = !this.props.options[field.name].length;
      var errorMessage = this.props.error && !disabled && typeof this.props.values[field.name] === 'undefined' ? 'Please choose an option' : undefined;
      return _react2.default.createElement(_select2.default, {
        name: field.name,
        label: field.label,
        placeholder: 'Please select',
        options: this.props.options[field.name],
        onChange: this.fetchOptions(field.action, field.name),
        disabled: disabled,
        fieldCss: index === fields.length - 1 ? {
          paddingBottom: 0
        } : undefined,
        key: field.name,
        error: errorMessage
      });
    }
  }, {
    key: 'createOptions',
    value: function createOptions() {
      var _this2 = this;
      return fields.map(function (field, i) {
        return _this2.createOption(i);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_glamorous2.default.Div, {
        paddingBottom: '3rem'
      }, _react2.default.createElement('a', {
        onClick: this.resetLookup
      }, this.props.reset), this.createOptions());
    }
  }]);
  return ManualLookup;
}(_react.Component);
ManualLookup.propTypes = {
  formId: _propTypes.string.isRequired,
  error: _propTypes.bool.isRequired,
  resetLookup: _propTypes.func.isRequired,
  reset: _propTypes.string.isRequired,
  // controlFields
  product: _propTypes2.product.isRequired,
  values: _propTypes.object.isRequired,
  // stp
  fetching: (0, _propTypes.shape)({
    manufacturerOptions: _propTypes.bool,
    modelOptions: _propTypes.bool,
    transOptions: _propTypes.bool,
    fuelOptions: _propTypes.bool,
    engineOptions: _propTypes.bool,
    trimOptions: _propTypes.bool,
    doorsOptions: _propTypes.bool,
    yearOptions: _propTypes.bool
  }).isRequired,
  options: (0, _propTypes.shape)({
    manufacturerOptions: _propTypes.array,
    modelOptions: _propTypes.array,
    transOptions: _propTypes.array,
    fuelOptions: _propTypes.array,
    engineOptions: _propTypes.array,
    trimOptions: _propTypes.array,
    doorsOptions: _propTypes.array,
    yearOptions: _propTypes.array
  }).isRequired,
  // dtp
  fetchOptions: _propTypes.func.isRequired
};
exports.default = (0, _controlFields2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    fetching: (0, _vehicleLookup.manualLookupFetching)(state, ownProps.formId),
    options: (0, _vehicleLookup.manualLookupOptions)(state, ownProps.formId)
  };
}, {
  fetchOptions: _vehicleLookup2.fetchManualLookupOptions
})(ManualLookup));